import React from 'react';

import { removeOption, addOption } from './handleChecked';

import {
  ISubscription,
  EventCategories,
  ChannelTypes,
  IEventChannel,
} from 'redux/reducers/subscriptions';

export default useCheckboxes;

function useCheckboxes(
  subscription: ISubscription,
  setSubscription: (func: any) => void
): [THandleChecked, TGetIsSelected] {
  const getIsSelected = React.useCallback(
    (category, channel) => {
      if (!subscription.eventChannels) {
        return false;
      }
      const result = subscription.eventChannels.some(
        (chan: IEventChannel): boolean => {
          return (
            chan.channelId === channel &&
            chan.eventCategories.indexOf(category) > -1
          );
        }
      );
      return result;
    },
    [subscription.eventChannels]
  );

  const handleChecked = React.useCallback(
    (channel, category, isSelected, isEditingMode = false) => {
      const handler = isSelected ? removeOption : addOption;
      if (subscription) {
        setSubscription(
          handler(channel, category, subscription, isEditingMode)
        );
      }
    },
    [subscription, setSubscription]
  );

  return [handleChecked, getIsSelected];
}

export type THandleChecked = (
  channel: ChannelTypes,
  category: EventCategories,
  isSelected: boolean,
  isEditingMode?: boolean
) => void;

export type TGetIsSelected = (
  category: EventCategories,
  channel: ChannelTypes | 'all'
) => boolean;
